import { LinkItem } from "../link-item";
import * as Styled from "./style";
import { useRouterForVodList } from "~/hooks/use-router-for-vod-list";
import type { G_GetVideoQuery, G_Person } from "~/lib/graphql";

type CastProps = {
  /** videoクエリを叩いて取得したデータ */
  videoData: G_GetVideoQuery["video"];
  /** 出演者以外の情報が存在するかどうか */
  hasNotCastData: boolean;
  /** グラビアかどうか(デフォルトは `false`) */
  isGravure?: boolean;
};

/** 作品情報ブロック | 出演者（Cast）の情報を描画するコンポーネント */
export const Cast = (props: CastProps) => {
  const { videoData, hasNotCastData, isGravure = false } = props;
  const { rating, categories } = videoData;
  const { buildVodListHref } = useRouterForVodList();

  const generateHref = (person: Pick<G_Person, "id">) => {
    const isRatingProduct = rating.category === "R15" || rating.category === "R18";
    const query = isRatingProduct
      ? { casts: `${person.id}`, categories: categories.map(({ id }) => id).join(",") }
      : { casts: `${person.id}` };

    return buildVodListHref({ query, isGravure });
  };

  return (
    <Styled.DivCastWrapper hasNotCastData={hasNotCastData}>
      <section>
        <Styled.Heading>出演者</Styled.Heading>

        {videoData.casts.map(({ person, castName, actorName }) => {
          const href = generateHref(person);
          return (
            <Styled.SecLinkWrapper key={person.id}>
              <LinkItem href={href}>
                {castName !== "" && <Styled.ParCharacterName>{castName}</Styled.ParCharacterName>}
                <Styled.DivActorName>{actorName}</Styled.DivActorName>
              </LinkItem>
            </Styled.SecLinkWrapper>
          );
        })}
      </section>
    </Styled.DivCastWrapper>
  );
};
